$(document).ready(function () {


    var startHeight = 120;
    var endHeight = 44;
    var maxScroll = 76;

    function headerShrink() {
        var scroll = $(window).scrollTop();

        var progress = Math.min(Math.max(scroll, 0), maxScroll);
        var ratio = progress / maxScroll;

        var height = startHeight - (startHeight - endHeight) * ratio;
        var height_logo = 76 - 76 * ratio;

        $('.home .header').css('height', height + 'px');
        $('.home .header__logo').css('height', height_logo + 'px');

        if (scroll >= maxScroll) {
            $('.home .header').addClass('is-collapsed');
        } else {
            $('.home .header').removeClass('is-collapsed');
        }
    }

    function enableShrink() {
        $(window).off('scroll.headerShrink').on('scroll.headerShrink', headerShrink);
        headerShrink();
    }

    function disableShrink() {
        $(window).off('scroll.headerShrink');

        $('.home .header').removeClass('is-collapsed').css('height', '');
        $('.home .header__logo').css('height', '');
    }

    function checkWidth() {
        if (window.innerWidth < 1024) {
            enableShrink();
        } else {
            disableShrink();
        }
    }

    checkWidth();
    $(window).on('resize.headerShrink', checkWidth);

    $('body').on('click', '.header__burger:not(.open)', function (e) {
        e.preventDefault();
        let that = $(this);
        that.addClass('opening')
        setTimeout(function () {
            that.removeClass('opening').addClass('open').attr('aria-label', 'Close Navigation Menu');
            $('main, footer').hide(0);
        }, 300);
        $('.header__nav').addClass('open').removeAttr('tabindex');
        $('.header').addClass('nav_open');
        $('.header__nav-menu > ul > li:first-child > a').focus();
        $('html, body').addClass('overflow_hidden');
    });

    $('body').on('click', '.header__burger.open', function (e) {
        e.preventDefault();
        $('main, footer').show(0);

        let that = $(this);
        that.removeClass('open').addClass('opening')
        setTimeout(function () {
            that.removeClass('opening').attr('aria-label', 'Open Navigation Menu');
        }, 300);
        $('.header__nav').removeClass('open');
        $('.header').removeClass('nav_open');
        $('html, body').removeClass('overflow_hidden');
    });


    $('body').on('click', '.header__nav-menu .menu-item-has-children>a:not(.open)', function (e) {
        e.preventDefault();
        $(this).addClass('open').attr('aria-expanded', true).siblings('.sub-menu').slideDown(150).attr('aria-hidden', false);
    });
    $('body').on('click', '.header__nav-menu .menu-item-has-children>a.open', function (e) {
        e.preventDefault();
        $(this).removeClass('open').attr('aria-expanded', false).siblings('.sub-menu').slideUp(150).attr('aria-hidden', true);
    });

    $(document).on('click', function (e) {
        const target = $(e.target);

        const subMenu = $('.sub-menu');
        const dropdownList = $('.dropdown_list');

        const safeSelectors = [
            '.header__nav-menu .menu-item-has-children > a',
            '.dropdown_checked',
            '.dropdown_list__item',
            '.sub-menu'
        ];

        const isClickOutside = !safeSelectors.some(selector =>
            target.is(selector) || target.closest(selector).length > 0
        );

        if (isClickOutside) {
            subMenu.slideUp(150).attr('aria-hidden', true);
            dropdownList.slideUp(150).attr('aria-hidden', true);
            $('.header__nav-menu .menu-item-has-children > a.open').removeClass('open').attr('aria-expanded', false);
            $('.dropdown_checked').removeClass('open');
            $('.dropdown_checked').attr('aria-expanded', false);
        }
    });

    $('.footer__bottom-go_to_top').click(function (e) {
        e.preventDefault();
        $('html, body').stop(true).animate({ scrollTop: 0 }, 500).promise().done(function () {
            const $target = $('main').first();
            if ($target.length) {
                const hadTabindex = $target.is('[tabindex]');
                $target.attr('tabindex', '-1').focus();
                if (!hadTabindex) {
                    setTimeout(() => $target.removeAttr('tabindex'), 100);
                }
            }
        });
    });

    $('body').on('click', '.accordion__header', function (e) {
        e.preventDefault();
        if ($(this).closest('.accordion').hasClass('open')) {
            $(this).attr('aria-expanded', 'false').closest('.accordion').removeClass('open');
            $(this).closest('.accordion').find('.accordion__content').attr('aria-hidden', 'true').slideUp(150);
        } else {
            $(this).attr('aria-expanded', 'true').closest('.accordion').addClass('open');
            $(this).closest('.accordion').find('.accordion__content').attr('aria-hidden', 'false').slideDown(150);
        }
    });


    $('body').on('focus', '.form-group input[type=email], .form-group input[type=tel], .form-group input[type=text], .form-group input[type=text], .form-group textarea', function () {
        $(this).closest('.form-group').addClass('focus');
    });

    $('body').on('blur', '.form-group input[type=email], .form-group input[type=tel], .form-group input[type=text], .form-group input[type=text], .form-group textarea', function () {
        if ($(this).val() === '') {
            $(this).closest('.form-group').removeClass('focus');
        }
    });

    $('[name="description-location"]').val(window.location.href);

    let lastFocusedElement = null;
    function openModal(push = true, trigger = null) {
        if (trigger) {
            lastFocusedElement = trigger;
        }

        $('body').addClass('modal_open');
        $('#schedule-showing').show(0);
        $('header, footer, main').attr('inert', '').attr('aria-hidden', 'true');
        $('#schedule-showing-close').focus();

        if (push) {
            history.pushState({modal: true}, '', '#schedule-showing');
        }
    }

    function closeModal(fromPopstate = false) {
        $('body').removeClass('modal_open');
        $('#schedule-showing').hide(0);
        $('header, footer, main').removeAttr('inert').removeAttr('aria-hidden');

        if (lastFocusedElement) {
            $(lastFocusedElement).focus();
            lastFocusedElement = null;
        }

        if (!fromPopstate) {
            history.back();
        }
    }

    $('body').on('click', '[href="#schedule-showing"]', function (e) {
        e.preventDefault();
        openModal(true, e.currentTarget);
    });

    $('body').on('click', '.modal__close, .wrapper_modal_backdrop', function (e) {
        e.preventDefault();
        closeModal();
    });

    $(document).on('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && $('#schedule-showing').is(':visible')) {
            closeModal();
        }
    });

    window.addEventListener('popstate', function (e) {
        if ($('#schedule-showing').is(':visible')) {
            closeModal(true);
        }
    });

    if (location.hash === '#schedule-showing') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        history.pushState({modal: true}, '', '#schedule-showing');
        openModal(false);
    }

    document.addEventListener('wpcf7invalid', function (event) {
        const form = event.target;
        setTimeout(function () {
            const firstErrorField = form.querySelector('.wpcf7-not-valid');
            if (firstErrorField) {
                firstErrorField.focus();
            }
        }, 100);

    }, false);

    if (window.location.hash) {
        const $target = $(window.location.hash);
        if ($target.length) {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $target.offset().top - 154
                }, 600);
            }, 100);
        }
    }
    if (window.location.hash) {
        const $target = $('#map');
        if ($target.length) {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 600);
            }, 100);
        }
    }

    $('.community_commitment > .wp-block-heading').attr('id', 'community_commitment');
    $('.community_commitment__content .wp-block-button__link').attr('id', 'community_commitment_link').attr('aria-labelledby', "community_commitment_link community_commitment");

    $('.small_featured_property__image img').attr('alt', '');
    $('.related_article__image img').attr('alt', '');
    $('.single_article__sidebar-popular ul li img').attr('alt', '');

    $('.engineer_card__show_properties').each(function (index){
        let id = $(this).siblings('.engineer_card__title').text().trim().replaceAll(' ', '-') + index;
        $(this).siblings('.engineer_card__title').attr('id', id);
        $(this).find('a').attr('id', id + '-2').attr('aria-labelledby', id + '-2' + ' ' + id);
    });

    $('.careers__list-item-link').each(function (index){
        let id = $(this).siblings('.wp-block-heading').text().trim().replaceAll(' ', '-') + index;
        $(this).siblings('.wp-block-heading').attr('id', id);
        $(this).find('a').attr('id', id + '-2').attr('aria-labelledby', id + '-2' + ' ' + id);
    });

    $('.pdf-download-block > img').attr('alt', '');
    $('.pdf-download-block > a').each(function (index){
        let id = $(this).siblings('strong').text().trim().replaceAll(' ', '-');
        $(this).siblings('strong').attr('id', id);
        $(this).attr('id', id + '-2').attr('aria-labelledby', id + '-2' + ' ' + id);
    });

    $('body').on('click', '.wpcf7 .screen-reader-response a',function (e){
        e.preventDefault();
        $($(this).attr('href')).focus();
    });

    document.addEventListener('wpcf7invalid', function (event) {

        const invalidFields = event.detail.apiResponse?.invalid_fields ?? [];

        const fieldNames = {
            "first-name": "First name",
            "emergency-first-name": "Emergency First name",
            "last-name": "Last name",
            "emergency-last-name": "Emergency Last name",
            "relationship-to-you": "relationship",
            "contact-us-email": "Email",
            "email-949": "Email",
            "contact-us-phone": "Phone",
            "cell-tel-563": "Cell Phone",
            "emergency-cell-tel-563": "Emergency Cell Phone",
            "address-222": "Address",
            "unit-222": "Unit",
            "city-222": "City",
            "textarea-362": "Message",
            "contact-us-message": "Message",
            "request-519": "Message"
        };


        invalidFields.forEach(function (field) {
            field.message = `Please fill out ${fieldNames[field.field]} field`;
        });
    });

    $('body').on('keydown', '.remove-file', function(e) {
        // e.preventDefault();
        console.log(e.originalEvent.key);
        if(e.originalEvent.key == 'Enter'){
            $(this).find('.dnd-icon-remove').trigger('click');
            $('.cd-upload-btn').focus();
        }
    });

    $('hr').attr('role', 'presentation');

    setTimeout(function (){
        $('[alt="Google"]').closest('a').css('display', 'block').css('outline-offset', '-2px');
    }, 1000);
    setTimeout(function (){
        $('[alt="Google"]').closest('a').css('display', 'block').css('outline-offset', '-2px');
    }, 2000);

    setTimeout(function(){
        $('#contact-us-message').attr('aria-describedby', 'help-instructions');
        $('[aria-label="Contact form"]').attr('aria-label', 'Contact');

        $('.cd-upload-btn').attr('aria-describedby', 'upload-help');
    }, 1000);
});


document.addEventListener('wpcf7mailsent', function (event) {
    if (event.detail.contactFormId === 17093) {

        $('#schedule-showing .modal__title').remove();

    }
    if (event.detail.contactFormId === 19339 || event.detail.contactFormId === 19341) {

        $('html, body').animate({scrollTop: 0}, 500);
        $('h1.wp-block-heading').remove();

    }
}, false);


window.updateAriaHidden = function (swiper) {
    swiper.slides.forEach((slide, index) => {
        if (index === swiper.activeIndex) {
            slide.setAttribute('aria-hidden', false);
        } else {
            slide.setAttribute('aria-hidden', true);
        }
    });
};
window.updateTabindex = function (swiper) {
    swiper.slides.forEach((slide, index) => {
        const focusableElements = slide.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
        if (index === swiper.activeIndex) {
            focusableElements.forEach(el => {
                el.removeAttribute('tabindex');
            });
        } else {
            focusableElements.forEach(el => {
                el.setAttribute('tabindex', '-1');
            });
        }
    });
};


function headerNavTabindex() {
    if($(window).width() >= 1024){
        $('.header__nav').removeAttr('tabindex');
    } else {
        $('.header__nav').attr('tabindex', '-1');
    }
}
$(document).ready(function () {
    headerNavTabindex();
    $(window).on('resize', headerNavTabindex);
});


function updateThumbLabels(swiper) {
    swiper.slides.forEach((slide) => {
        const oldSr = slide.querySelector(".sr-only");
        if (oldSr) oldSr.remove();
        const img = slide.querySelector("img");
        if (!img) return;

        if (slide.classList.contains("swiper-slide-thumb-active")) {
            const sr = document.createElement("span");
            sr.className = "sr-only";
            sr.textContent = "Selected ";
            $(slide).find('button').prepend(sr);
        }
    });
}
function updateThumbAccessibility(swiper) {
    swiper.slides.forEach((slide) => {
        const btn = slide.querySelector('button');
        if (!btn) return;

        const isVisible = slide.classList.contains('swiper-slide-visible');
        const isActive = slide.classList.contains('swiper-slide-thumb-active');

        btn.removeAttribute('aria-hidden');
        btn.removeAttribute('aria-current');
        btn.removeAttribute('tabindex');

        if (!isVisible) {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-hidden', 'true');
            return;
        }

        if (isActive) {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-current', 'true');
            return;
        }

    });
}
function updateBuildingAccessibility(swiper) {
    swiper.slides.forEach((slide) => {
        const isVisible = slide.classList.contains('swiper-slide-visible');

        const interactiveEls = slide.querySelectorAll('a, button, [tabindex], input, select, textarea');

        interactiveEls.forEach((el) => {
            el.removeAttribute('aria-hidden');
            el.removeAttribute('aria-current');
            el.removeAttribute('tabindex');

            if (!isVisible) {
                el.setAttribute('tabindex', '-1');
                el.setAttribute('aria-hidden', 'true');
            }
        });
    });
}

window.updateThumbLabels = updateThumbLabels;
window.updateThumbAccessibility = updateThumbAccessibility;
window.updateBuildingAccessibility = updateBuildingAccessibility;